import service from "./service"

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const preCheckFormUpdateId = async (key, formUpdateId) => {
    const MAX_RETRIES = 5

    for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
        await sleep(3000)

        const result = await service(key)

        if (result.formUpdateId !== formUpdateId) {
            return result
        }
    }

    throw new Error("formUpdateId did not change after maximum retries")
}

export default preCheckFormUpdateId
